module.exports = __webpack_public_path__ + "static/img/home-1.900af5c7.png";